import { Component } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { AuthService } from 'app/core/auth.service';
import { GenesisUnitOfWork } from 'app/core/core.module';
import { PaymentCredit } from 'app/core/model/payment-credit';
import { PaymentCreditType } from 'app/core/model/payment-credit-type';
import validationEngine from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-payment-credit-dialog',
    templateUrl: './payment-credit-dialog.component.html',
    styleUrls: ['./payment-credit-dialog.component.scss'],
    standalone: false
})
export class PaymentCreditDialogComponent {
    result: Subject<any> = new Subject<any>();
    paymentCredit: PaymentCredit;
    paymentCreditTypes: PaymentCreditType[];
    dealerId: number;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private auth: AuthService, private appInfo: AppInformationService) {}

    async ngOnInit() {
         const paymentCreditTypes = (await this.uow.paymentCreditTypes.whereActive('displayOrder, name')) as PaymentCreditType[];
        this.paymentCreditTypes = paymentCreditTypes.filter(x => {if (x.id !== PaymentCreditType.Types.OverPayment) return x})
        if (!this.paymentCredit) {
            this.paymentCredit = this.uow.paymentCredits.createEntity({
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
                dealerId: this.dealerId,
                // clear for validation
                paymentCreditTypeId: null,
            }) as PaymentCredit;
        }
    }

    async save() {
        const success = this.validate();
        if (!success) return;

        await this.uow.commit([this.paymentCredit]);
        this.result.next({ success: true, value: this.paymentCredit });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\r\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\r\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    close() {
        this.uow.rollback();
        this.result.next(false);
    }
}
